import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Don't scroll to top if there's a hash – let hash scrolling handle it
        if (hash) return;
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });

        // Run once after the new route has been painted (avoids fighting async layout)
        let cancelled = false;
        const id = requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                if (!cancelled) {
                    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
                }
            });
        });
        return () => {
            cancelled = true;
            cancelAnimationFrame(id);
        };
    }, [pathname]);

    return null;
}